import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useDispatch, useSelector } from "react-redux";
import Statistics from "./components/Statistics";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { startOfDay } from "date-fns";
import SubscriptionsTable from "./components/SubscriptionTable";
import { getSubscriptionDailyReport } from "store/slice/subscriptions/subscriptionSlice";
import moment from "moment";
import PlaceStatistics from "./components/placeStatisticsCard";
import CircularIndeterminate from "components/MDLoading";
import EmptyTableRowOverlay from "components/MDEmptyOverlay/EmptyTableRowOverlay";

function SubscriptionReport() {
  const dispatch = useDispatch();
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const report = useSelector((state) => state.subscriptions.dailyReport);
  const [selectedDate, setSelectedDate] = useState(startOfDay(new Date()));
  const [loading, setLoading] = useState(false);

  const handleDateChange = (newDate) => {
    setSelectedDate(startOfDay(newDate));
  };

  useEffect(() => {
    if (selectedDate) {
      setLoading(true); // Show loading spinner when API request starts
      const formattedDate = moment(selectedDate).format("YYYY-MM-DD");

      // Dispatch API call
      dispatch(getSubscriptionDailyReport(formattedDate))
        .then(() => {
          setLoading(false); // Hide loading spinner after data is fetched
        })
        .catch(() => {
          setLoading(false); // Hide loading spinner in case of error
        });
    }
  }, [dispatch, selectedDate]);

  const hasData =
    report !== null &&
    report !== undefined &&
    !Array.isArray(report) &&
    typeof report === "object" &&
    Object.keys(report).length > 0;


  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox>
          <MDBox pt={2} pb={3}>
            <Grid container spacing={6}>
              <Grid item xs={12}>
                <Card>
                  <MDBox
                    mx={1}
                    mt={-2}
                    py={1}
                    px={1}
                    variant="gradient"
                    bgColor={sidenavColor}
                    borderRadius="lg"
                    coloredShadow={sidenavColor}
                    className="d-flex align-items-center gap-2"
                  >
                    <MDTypography
                      variant="h6"
                      color="white"
                      className="flex-grow-1"
                    >
                      Subscription Report
                    </MDTypography>
                  </MDBox>

                  <MDBox p={2}>
                    <Grid container spacing={4}>
                      <Grid item xs={12} md={3}>
                        <DesktopDatePicker
                          name="selectedDate"
                          label="Select Date"
                          sx={{ width: "100%", mb: 1 }}
                          value={selectedDate}
                          onChange={handleDateChange}
                          format="MM/dd/yyyy"
                          slots={{ textField: TextField }}
                        />
                      </Grid>
                    </Grid>
                  </MDBox>

                  {/* Show loading or the data based on `hasData` */}
                  {loading ? (
                    <CircularIndeterminate
                      type="full"
                      size={20}
                      text="Please wait..."
                      open={loading}
                    />
                  ) : hasData ? (
                    <>
                      <MDBox p={2}>
                        <Statistics data={report?.statistics || {}} />
                      </MDBox>

                      <MDBox p={2}>
                        <PlaceStatistics data={report?.placeStatistics || []} />
                      </MDBox>

                      <MDBox p={2}>
                        <SubscriptionsTable
                          isLoading={false}
                          subscriptionList={report?.subscriptionsList || []}
                        />
                      </MDBox>
                    </>
                  ) : (
                    <EmptyTableRowOverlay />
                  )}
                </Card>
              </Grid>
            </Grid>
          </MDBox>
        </MDBox>
        <Footer />
      </DashboardLayout>
    </LocalizationProvider>
  );
}

export default SubscriptionReport;
